import { capacityDisplayLogic } from 'shared/helpers';
import { 
  find,
  isEmpty, 
  isNull,
  isUndefined,
} from 'lodash';
import { LOCATION_EVENT_STATUS } from 'shared/constants';

export const calculateTotal = (locationEvents, locations, capacityTypes) => {
  let total = 0;

  locations.map(location => {
    if (location.locationEvent.status !== LOCATION_EVENT_STATUS.closed) {
      capacityTypes.map(type => {
        const capacityType = capacityDisplayLogic(location, type, true);
        if(!isNull(capacityType.capacity)) {
          total += +capacityType.capacity;
        }
      });
    }
  });

  return total;
};

export const calculateNewTotal = (locationEvents, locations, capacityTypes) => {
  let total = 0;

  locations.map(location => {
    capacityTypes.map(type => {
      const capacityType = capacityDisplayLogic(location, type, true);
      if(!isNull(capacityType.capacity)) {
        let newCapacity = 0;
        const locationCapacities = find(locationEvents, {locationId: location.id});
        if(!isEmpty(locationCapacities)) {
          newCapacity = find(locationCapacities.capacities, {capacityTypeId: type.id}) || 0;
        }

        if ((isEmpty(locationCapacities) && location.locationEvent.status !== LOCATION_EVENT_STATUS.closed)
          || (locationCapacities && ((locationCapacities.status && locationCapacities.status.toUpperCase() !== LOCATION_EVENT_STATUS.closed) || !locationCapacities.status))) {
          total += !isUndefined(newCapacity.capacity) ? +newCapacity.capacity : +capacityType.capacity;
        }
      }
    });
  });

  return total;
}